import { TInactiveAccountResponse } from "../../types/Account.type";
import { TAccountsOverviewResponse } from "../../types/AccountOverview.type";
import { baseUrl, extendHeaders } from "./HelpService";

type TApiResponse =
    | { message: "success";[key: string]: any }
    | { message: "error"; code: string;[key: string]: any };

const PageUrl = baseUrl + 'accounts/';

const getAccounts = (): Promise<Response | null> => {
    return fetch(PageUrl, {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const getAccountList = (): Promise<Response | null> => {
    return fetch(PageUrl + "getAccountList/", {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const getAccountDetailsList = (): Promise<Response | null> => {
    return fetch(PageUrl + 'getAccountsDetails/', {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const getAccountListByUser = (user_id): Promise<Response | null> => {
    return fetch(PageUrl + "getAccountListByUser/?user_id=" + user_id, {
        method: "GET",
        headers: extendHeaders()
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        })
};

const returnAddAccountIsAvailable = (user_id = null): Promise<Response | null> => {
    const queryParams = new URLSearchParams();
    if (user_id && user_id !== undefined) {
        queryParams.set('user_id', user_id);
    }
    const search = queryParams.toString();
    return fetch(PageUrl + `returnAddAccountIsAvailable/?${search}`, {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const activeOrDeleteAccount = (account_id: number, status): Promise<Response | null> => {
    return fetch(PageUrl + "updateStatus/", {
        method: "PUT",
        headers: extendHeaders(),
        body: JSON.stringify({ account_id: account_id, status: status })
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const addAccount = (user_id, account): Promise<TApiResponse> => {
    return fetch(PageUrl, {
        method: "POST",
        headers: extendHeaders(),
        body: JSON.stringify({ user_id: user_id, account_name: account })
    })
        .then((response: any) => {
            if (!response.ok) {
                return response.json().then((data: any) => {
                    return {
                        message: "error",
                        code: data?.code || "server_error",
                        ...data
                    } as TApiResponse;
                });
            }
            return response.json().then((data: any) => ({
                message: "success",
                ...data
            } as TApiResponse));
        })
        .then((data: any) => data as TApiResponse)
        .catch((error) => {
            return {
                message: "error",
                code: "network_error"
            } as TApiResponse;
        });
};

const updateAccount = (account_id: number, account_details: {}): Promise<Response | null> => {
    return fetch(PageUrl + `${account_id}/`, {
        method: "PUT",
        headers: extendHeaders(),
        body: JSON.stringify(account_details)
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const getAccountDetails = (account_id: number): Promise<Response | null> => {
    return fetch(PageUrl + `${account_id}/`, {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const checkIsInactiveAccount = (account_id: number): Promise<TInactiveAccountResponse | null> => {
    return fetch(PageUrl + `checkIsInactiveAccount/?account_id=${encodeURIComponent(account_id)}`, {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const checkIsAryehAnalyst = (account_id) => {
    return fetch(PageUrl + `checkIsAryehAnalyst/?account_id=${encodeURIComponent(account_id)}`, {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .catch((error) => {
            return null;
        });
};

const checkIfNeedUserAuthorizationStep = (account_id) => {
    return fetch(PageUrl + `checkIfNeedUserAuthorizationStep/?account_id=${encodeURIComponent(account_id)}`, {
        method: "GET",
        headers: extendHeaders()
    })
        .then((response) => response.json())
        .catch(error => {
            return null;
        });
};

const updateIsSendInvite = (account_id, is_send_invite) => {
    return fetch(PageUrl + `updateIsSendInvite/`, {
        method: "POST",
        headers: extendHeaders(),
        body: JSON.stringify({ account_id: account_id, is_send_invite: is_send_invite })
    })
        .then((response) => response.json())
        .catch(error => {
            return null;
        });
};

const getSummaryReimbursements = (account_id) => {
    return fetch(PageUrl + `getSummaryReimbursements/?account_id=${encodeURIComponent(account_id)}`, {
        method: "GET",
        headers: extendHeaders()
    })
        .then((response) => response.json())
        .catch(error => {
            return null;
        });
};


const sendSummaryReimbursementsEmail = (account_id) => {
    return fetch(PageUrl + `sendSummaryReimbursementsEmail/`, {
        method: "POST",
        headers: extendHeaders(),
        body: JSON.stringify({ account_id: account_id })
    })
        .then((response) => response.json())
        .catch(error => {
            return null;
        });
};
const setAccountUrl = (account_id: number, amazon_authorized_url: string) => {
    return fetch(PageUrl + 'setAccountUrl/', {
        method: 'POST',
        headers: extendHeaders(),
        body: JSON.stringify({ account_id, amazon_authorized_url })
    })
        .then((response) => response.json())
        .catch(error => {
            return null;
        });
};

const handleAccountUrlReview = (account_id: number, action: string, reason?: string) => {
    return fetch(PageUrl + 'handleAccountUrlReview/', {
        method: 'POST',
        headers: extendHeaders(),
        body: JSON.stringify({ account_id, action, reason })
    })
        .then((response) => response.json())
        .catch(error => null);
};

const completeAmazonUrlOnboarding = async (account_id: number) => {
    const res = await fetch(PageUrl + "completeAmazonUrlOnboarding/", {
        method: "POST",
        headers: extendHeaders(),
        body: JSON.stringify({ account_id }),
    });
    const data = await res.json().catch(() => null);
    if (!res.ok) {
        const code = data?.code;
        const msg = data?.message || "";
        if (code === "AMAZON_URL_NOT_APPROVED") {
            throw new Error("Can complete only after APPROVED");
        }
    }
    return data;
};

const confirmAmazonInvitationAccepted = async (account_id: number) => {
  const res = await fetch(PageUrl + "confirmAmazonInvitationAccepted/", {
    method: "POST",
    headers: extendHeaders(),
    body: JSON.stringify({ account_id }),
  });

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    const code = data?.code;
    const msg = data?.message || "";

    if (code === "AMAZON_URL_INVALID_STATUS") {
      throw new Error(msg || "Invalid status for confirm");
    }
    throw new Error(msg || "Request failed");
  }
  return data;
};

const getAccountsOverview = async (page: number = 1, pageSize: number = 10): Promise<TAccountsOverviewResponse | null> => {
  const queryParams = new URLSearchParams();
  queryParams.set('page', page.toString());
  queryParams.set('page_size', pageSize.toString());
  try {
    const res = await fetch(PageUrl + `overview/?${queryParams.toString()}`, {
      method: "GET",
      headers: extendHeaders(),
    });

    if (!res.ok) {
      const errText = await res.text().catch(() => '');
      console.error('getAccountsOverview failed', res.status, errText);
      return null;
    }

    return (await res.json()) as TAccountsOverviewResponse;
  } catch (err) {
    if (err instanceof DOMException && err.name === 'AbortError') {
      return null;
    }
    console.error('getAccountsOverview error', err);
    return null;
  }
};


const AccountService = {
    getAccounts,
    getAccountList,
    getAccountDetailsList,
    getAccountListByUser,
    returnAddAccountIsAvailable,
    activeOrDeleteAccount,
    addAccount,
    updateAccount,
    getAccountDetails,
    checkIsInactiveAccount,
    checkIsAryehAnalyst,
    checkIfNeedUserAuthorizationStep,
    updateIsSendInvite,
    getSummaryReimbursements,
    sendSummaryReimbursementsEmail,
    setAccountUrl,
    handleAccountUrlReview,
    completeAmazonUrlOnboarding,
    confirmAmazonInvitationAccepted,
    getAccountsOverview,
};

export default AccountService;
